module.exports = __webpack_public_path__ + "static/media/mail-icon-bg--red.258d61c9.svg";